
import React, { useState, useEffect, useMemo } from 'react';
import { useTheme } from '@/components/theme/ThemeProvider';
import { useMobile } from '@/hooks/use-mobile';
import { generateNodeData, prepareChartData } from './network/NetworkDataUtils';
import { NodeData } from './network/NetworkTypes';
import { NetworkChart } from './network/NetworkChart';
import { NodeTypeLegend } from './network/NodeTypeLegend';

const MeshNetworkGraph: React.FC = () => {
  const [nodes, setNodes] = useState<NodeData[]>([]);
  const [chartData, setChartData] = useState<any[]>([]);
  const { resolvedTheme } = useTheme();
  const isMobile = useMobile();
  const isDark = resolvedTheme === 'dark';
  
  useEffect(() => {
    const nodeData = generateNodeData(24);
    setNodes(nodeData);
    setChartData(prepareChartData(nodeData));
    
    const interval = setInterval(() => {
      const newNodeData = generateNodeData(24);
      setNodes(newNodeData);
      setChartData(prepareChartData(newNodeData));
    }, 2000);
    
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      @keyframes flow {
        0% {
          stroke-opacity: 0.7;
        }
        50% {
          stroke-opacity: 1;
        }
        100% {
          stroke-opacity: 0.7;
        }
      }
    `;
    document.head.appendChild(styleElement);
    
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const networkGroups = useMemo(() => {
    return nodes.reduce((acc, node) => {
      if (!acc[node.network]) {
        acc[node.network] = [];
      }
      acc[node.network].push(node);
      return acc;
    }, {} as Record<string, NodeData[]>);
  }, [nodes]);

  return (
    <div className="w-full h-full flex flex-col">
      <NetworkChart 
        chartData={chartData}
        nodes={nodes}
        networkGroups={networkGroups}
        isDark={isDark}
        isMobile={isMobile}
      />
      <NodeTypeLegend />
    </div>
  );
};

export default MeshNetworkGraph;
